import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import VerticalMediaCard from './card/VerticalMediaCard';
const ModuleView = ({ items, maxItems, 
// viewAction,
// eslint-disable-next-line @typescript-eslint/no-unused-vars
registerAction, }) => {
    console.log('Render ModuleView');
    if (!items) {
        return null;
    }
    return (_jsx(Grid, { container: true, spacing: 2, alignContent: "center", justifyContent: "left", children: items && items.slice(0, maxItems).map((item) => (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, lg: 3, xl: 2, sx: {
                minWidth: '304px',
            }, children: _jsx(VerticalMediaCard, { size: "large", item: item }) }, item.id))) }));
};
ModuleView.defaultProps = {
    // viewAction: undefined,
    registerAction: undefined,
    maxItems: 100,
};
export default observer(ModuleView);
//# sourceMappingURL=ModuleView.js.map